module.exports = __webpack_public_path__ + "img/wind.3adb048d.svg";